
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import Kling40Landing, { Kling40LandingProps, } from '@/components/videos/kling/Kling40Landing';
import { getExtendVideoCredits, getExtendVideoModel, } from '@/constants/videoExtend';
import { getVideoModelCredits, KLING_40_EDIT_CREDITS_PER_SECOND, KLING_40_EDIT_MAX_SECONDS, KLING_40_EDIT_MIN_SECONDS, videoModelsWithDescription, } from '@/constants/videoModels';
export default function Kling40LandingPage(props: Kling40LandingProps) {
    return <Kling40Landing {...props}/>;
}
/**
 * The calculator's rates are read from the same catalogue the API bills from,
 * so the page can never quote a different price. Only these numbers reach the
 * browser — the catalogue and its icons stay out of the page bundle.
 */
const getStaticProps: GetStaticProps<Kling40LandingProps> = async () => {
    const entry = videoModelsWithDescription.find((model) => model.title === 'Kling 4.0');
    const extend = getExtendVideoModel('kling-4-0');
    // Per-second rates, taken over 10 seconds so the round-up of a fractional
    // rate can't skew them.
    const perSecond = (credits: number) => credits / 10;
    return {
        props: {
            pricing: {
                generation: {
                    '720p': perSecond(getVideoModelCredits('Kling 4.0', '10', '720p')),
                    '1080p': perSecond(getVideoModelCredits('Kling 4.0', '10', '1080p')),
                },
                extend: {
                    '720p': perSecond(getExtendVideoCredits('kling-4-0', '10', '720p')),
                    '1080p': perSecond(getExtendVideoCredits('kling-4-0', '10', '1080p')),
                },
                edit: {
                    '720p': KLING_40_EDIT_CREDITS_PER_SECOND['720p'],
                    '1080p': KLING_40_EDIT_CREDITS_PER_SECOND['1080p'],
                },
                durations: (entry?.options.duration ?? []).map((value) => parseInt(String(value), 10)),
                extendDurations: (extend?.durations ?? []).map((value) => parseInt(String(value), 10)),
                editRange: [KLING_40_EDIT_MIN_SECONDS, KLING_40_EDIT_MAX_SECONDS],
            },
        },
    };
};

    async function __Next_Translate__getStaticProps__1a16c8c4e39__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-video-generator/kling-4-0',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a16c8c4e39__ as getStaticProps }
  